// src/components/Admin/shared/StatusBadge.jsx
import React from "react";

const statusStyles = {
  active: "bg-emerald-100 text-emerald-800 border-emerald-200",
  inactive: "bg-gray-100 text-gray-600 border-gray-200",
  draft: "bg-amber-100 text-amber-800 border-amber-200",
};

const statusLabels = {
  active: "Active",
  inactive: "Inactive",
  draft: "Draft",
};

const StatusBadge = ({ status, size = "sm" }) => {
  const style = statusStyles[status] || statusStyles.inactive;
  const label = statusLabels[status] || status;

  const sizeClasses =
    size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-sm";

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border ${style} ${sizeClasses}`}
    >
      <span
        className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
          status === "active"
            ? "bg-emerald-500"
            : status === "draft"
              ? "bg-amber-500"
              : "bg-gray-400"
        }`}
      />
      {label}
    </span>
  );
};

export default StatusBadge;
